var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46928 8.30106C10.5137 7.49766 10.7146 5.9712 9.87099 4.92678C9.02741 3.88235 7.54112 3.6815 6.4967 4.52508C5.45228 5.36865 5.25142 6.85494 6.095 7.89936C6.21551 8.06004 6.33602 8.18055 6.4967 8.30106C5.13091 8.86345 4.16683 10.1087 4.00615 11.595C3.96598 11.836 4.12666 11.9967 4.36768 12.0369C4.6087 12.0771 4.76938 11.9164 4.80955 11.6754C5.0104 9.90787 6.61721 8.62243 8.34452 8.82328C9.83081 8.98396 10.9957 10.1489 11.1966 11.6754C11.2368 11.8762 11.3974 12.0369 11.5983 12.0369H11.6385C11.8393 11.9967 12 11.7959 12 11.595C11.7991 10.1087 10.8351 8.86345 9.46928 8.30106ZM7.98299 8.01987C7.09925 8.01987 6.37619 7.29681 6.37619 6.41307C6.37619 5.52933 7.09925 4.80627 7.98299 4.80627C8.86673 4.80627 9.58979 5.52933 9.58979 6.41307C9.58979 7.29681 8.86673 8.01987 7.98299 8.01987Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.128bef14e856904085d524fe4fe2dcf7.svg";
export { ForwardRef as ReactComponent };